import axios from "axios";

export default {
  isValidAddress(address, currency, network, addressFormat, self) {
    const starkwareValidatorURL = `https://alpha-mainnet.starknet.io/feeder_gateway/get_code?contractAddress=${address}`;

    return axios
      .get(starkwareValidatorURL)
      .then((data) => {
        return !!(data.data.bytecode && data.data.bytecode.length > 0);
      })
      .catch((error) => {
        return false;
      });
  },
};
